import { useEffect, useState } from 'react';
import Header from '../../../components/feature/Header';
import Footer from '../../../components/feature/Footer';
import { Link } from 'react-router-dom';

const NewMexico = () => {
  const [showAllCities, setShowAllCities] = useState(false);

  useEffect(() => {
    // Update page meta tags
    document.title = 'We Buy Valves New Mexico | Industrial Equipment Buyers Albuquerque Artesia Hobbs';
    
    // Update meta description
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'Professional valve buyers New Mexico - We buy surplus valves, Fisher control valves, instrumentation from Albuquerque, Artesia, Hobbs, Carlsbad refineries. Same-day response 214-854-5638.');
    }
    
    // Update meta keywords
    const metaKeywords = document.querySelector('meta[name="keywords"]');
    if (metaKeywords) {
      metaKeywords.setAttribute('content', 'valve buyers new mexico, surplus valves albuquerque, fisher control valves artesia, refinery equipment hobbs');
    }
    
    // Update canonical URL
    const canonicalLink = document.querySelector('link[rel="canonical"]');
    if (canonicalLink) {
      canonicalLink.setAttribute('href', 'https://valvesalessupply.com/states/new-mexico');
    }

    // Add geo meta tags for New Mexico
    const geoRegion = document.createElement('meta');
    geoRegion.setAttribute('name', 'geo.region');
    geoRegion.setAttribute('content', 'US-NM');
    document.head.appendChild(geoRegion);

    const geoPlacename = document.createElement('meta');
    geoPlacename.setAttribute('name', 'geo.placename');
    geoPlacename.setAttribute('content', 'New Mexico');
    document.head.appendChild(geoPlacename);

    // Comprehensive Schema.org structured data
    const schemaData = {
      "@context": "https://schema.org",
      "@graph": [
        {
          "@type": "WebPage",
          "@id": "https://valvesalessupply.com/states/new-mexico/#webpage",
          "url": "https://valvesalessupply.com/states/new-mexico",
          "name": "We Buy Valves New Mexico | Industrial Equipment Buyers Albuquerque Artesia Hobbs",
          "description": "Professional valve buyers New Mexico - We buy surplus valves, Fisher control valves, instrumentation from Albuquerque, Artesia, Hobbs, Carlsbad refineries. Same-day response 214-854-5638.",
          "breadcrumb": {
            "@type": "BreadcrumbList",
            "itemListElement": [
              {
                "@type": "ListItem",
                "position": 1,
                "name": "Home",
                "item": "https://valvesalessupply.com"
              },
              {
                "@type": "ListItem",
                "position": 2,
                "name": "Service Areas",
                "item": "https://valvesalessupply.com/service-areas"
              },
              {
                "@type": "ListItem",
                "position": 3,
                "name": "New Mexico",
                "item": "https://valvesalessupply.com/states/new-mexico"
              }
            ]
          }
        },
        {
          "@type": "LocalBusiness",
          "@id": "https://valvesalessupply.com/states/new-mexico/#business",
          "name": "ValveSalesSupply - New Mexico Valve Buyers",
          "image": "https://public.readdy.ai/ai/img_res/2e18a7ddc20ecf2f685c7b155b11c040.jpg",
          "telephone": "214-854-5638",
          "priceRange": "$$",
          "address": {
            "@type": "PostalAddress",
            "addressRegion": "NM",
            "addressCountry": "US"
          },
          "geo": {
            "@type": "GeoCoordinates",
            "latitude": "34.5199",
            "longitude": "-105.8701"
          },
          "areaServed": [
            {
              "@type": "City",
              "name": "Albuquerque",
              "containedInPlace": {
                "@type": "State",
                "name": "New Mexico"
              }
            },
            {
              "@type": "City",
              "name": "Artesia",
              "containedInPlace": {
                "@type": "State",
                "name": "New Mexico"
              }
            },
            {
              "@type": "City",
              "name": "Hobbs",
              "containedInPlace": {
                "@type": "State",
                "name": "New Mexico"
              }
            },
            {
              "@type": "City",
              "name": "Carlsbad",
              "containedInPlace": {
                "@type": "State",
                "name": "New Mexico"
              }
            },
            {
              "@type": "City",
              "name": "Roswell",
              "containedInPlace": {
                "@type": "State",
                "name": "New Mexico"
              }
            },
            {
              "@type": "City",
              "name": "Las Cruces",
              "containedInPlace": {
                "@type": "State",
                "name": "New Mexico"
              }
            },
            {
              "@type": "City",
              "name": "Santa Fe",
              "containedInPlace": {
                "@type": "State",
                "name": "New Mexico"
              }
            },
            {
              "@type": "City",
              "name": "Rio Rancho",
              "containedInPlace": {
                "@type": "State",
                "name": "New Mexico"
              }
            },
            {
              "@type": "City",
              "name": "Farmington",
              "containedInPlace": {
                "@type": "State",
                "name": "New Mexico"
              }
            },
            {
              "@type": "City",
              "name": "Clovis",
              "containedInPlace": {
                "@type": "State",
                "name": "New Mexico"
              }
            },
            {
              "@type": "City",
              "name": "Gallup",
              "containedInPlace": {
                "@type": "State",
                "name": "New Mexico"
              }
            },
            {
              "@type": "City",
              "name": "Alamogordo",
              "containedInPlace": {
                "@type": "State",
                "name": "New Mexico"
              }
            },
            {
              "@type": "City",
              "name": "Lovington",
              "containedInPlace": {
                "@type": "State",
                "name": "New Mexico"
              }
            },
            {
              "@type": "City",
              "name": "Deming",
              "containedInPlace": {
                "@type": "State",
                "name": "New Mexico"
              }
            },
            {
              "@type": "City",
              "name": "Portales",
              "containedInPlace": {
                "@type": "State",
                "name": "New Mexico"
              }
            },
            {
              "@type": "City",
              "name": "Aztec",
              "containedInPlace": {
                "@type": "State",
                "name": "New Mexico"
              }
            },
            {
              "@type": "City",
              "name": "Bloomfield",
              "containedInPlace": {
                "@type": "State",
                "name": "New Mexico"
              }
            },
            {
              "@type": "City",
              "name": "Belen",
              "containedInPlace": {
                "@type": "State",
                "name": "New Mexico"
              }
            },
            {
              "@type": "City",
              "name": "Bernalillo",
              "containedInPlace": {
                "@type": "State",
                "name": "New Mexico"
              }
            },
            {
              "@type": "City",
              "name": "Espanola",
              "containedInPlace": {
                "@type": "State",
                "name": "New Mexico"
              }
            },
            {
              "@type": "City",
              "name": "Grants",
              "containedInPlace": {
                "@type": "State",
                "name": "New Mexico"
              }
            },
            {
              "@type": "City",
              "name": "Las Vegas",
              "containedInPlace": {
                "@type": "State",
                "name": "New Mexico"
              }
            },
            {
              "@type": "City",
              "name": "Los Alamos",
              "containedInPlace": {
                "@type": "State",
                "name": "New Mexico"
              }
            },
            {
              "@type": "City",
              "name": "Los Lunas",
              "containedInPlace": {
                "@type": "State",
                "name": "New Mexico"
              }
            },
            {
              "@type": "City",
              "name": "Raton",
              "containedInPlace": {
                "@type": "State",
                "name": "New Mexico"
              }
            },
            {
              "@type": "City",
              "name": "Ruidoso",
              "containedInPlace": {
                "@type": "State",
                "name": "New Mexico"
              }
            },
            {
              "@type": "City",
              "name": "Silver City",
              "containedInPlace": {
                "@type": "State",
                "name": "New Mexico"
              }
            },
            {
              "@type": "City",
              "name": "Socorro",
              "containedInPlace": {
                "@type": "State",
                "name": "New Mexico"
              }
            },
            {
              "@type": "City",
              "name": "Sunland Park",
              "containedInPlace": {
                "@type": "State",
                "name": "New Mexico"
              }
            },
            {
              "@type": "City",
              "name": "Taos",
              "containedInPlace": {
                "@type": "State",
                "name": "New Mexico"
              }
            },
            {
              "@type": "City",
              "name": "Truth or Consequences",
              "containedInPlace": {
                "@type": "State",
                "name": "New Mexico"
              }
            },
            {
              "@type": "City",
              "name": "Tucumcari",
              "containedInPlace": {
                "@type": "State",
                "name": "New Mexico"
              }
            }
          ],
          "openingHoursSpecification": [
            {
              "@type": "OpeningHoursSpecification",
              "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
              "opens": "08:00",
              "closes": "18:00"
            },
            {
              "@type": "OpeningHoursSpecification",
              "dayOfWeek": "Saturday",
              "opens": "09:00",
              "closes": "15:00"
            }
          ],
          "hasOfferCatalog": {
            "@type": "OfferCatalog",
            "name": "Industrial Equipment Purchasing Services",
            "itemListElement": [
              {
                "@type": "Offer",
                "itemOffered": {
                  "@type": "Service",
                  "name": "Fisher Control Valves Purchase - New Mexico",
                  "description": "We buy Fisher control valves from Albuquerque, Artesia, Hobbs refineries and gas processing plants"
                }
              },
              {
                "@type": "Offer",
                "itemOffered": {
                  "@type": "Service",
                  "name": "Surplus Valve Purchase - Permian Basin NM",
                  "description": "Purchase surplus gate valves, globe valves, ball valves from New Mexico Permian Basin operations"
                }
              },
              {
                "@type": "Offer",
                "itemOffered": {
                  "@type": "Service",
                  "name": "Rosemount Instrumentation Purchase - New Mexico",
                  "description": "Buy Rosemount transmitters, pressure gauges, flow meters from New Mexico facilities"
                }
              },
              {
                "@type": "Offer",
                "itemOffered": {
                  "@type": "Service",
                  "name": "Refinery Equipment Purchase - Artesia",
                  "description": "Purchase refinery equipment, heat exchangers, pumps from Artesia and Gallup refineries"
                }
              },
              {
                "@type": "Offer",
                "itemOffered": {
                  "@type": "Service",
                  "name": "Gas Processing Equipment - Carlsbad Hobbs",
                  "description": "Buy gas processing valves, compressors, separators from Carlsbad and Hobbs facilities"
                }
              },
              {
                "@type": "Offer",
                "itemOffered": {
                  "@type": "Service",
                  "name": "Pipeline Valve Purchase - New Mexico",
                  "description": "Purchase pipeline valves, actuators, controls from interstate pipeline systems"
                }
              }
            ]
          }
        },
        {
          "@type": "FAQPage",
          "@id": "https://valvesalessupply.com/states/new-mexico/#faq",
          "mainEntity": [
            {
              "@type": "Question",
              "name": "What types of valves do you buy in New Mexico?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "We buy all types of industrial valves from New Mexico refineries including Fisher control valves, gate valves, globe valves, ball valves, check valves, butterfly valves, and safety relief valves. We purchase from Western Refining Gallup, Artesia refineries, and Permian Basin facilities throughout Albuquerque, Hobbs, Carlsbad, and Roswell areas."
              }
            },
            {
              "@type": "Question",
              "name": "How quickly can you respond to New Mexico facilities?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "We provide same-day response to all New Mexico refineries and processing facilities. Our regional team can typically be on-site within 3-6 hours for equipment assessments throughout New Mexico, including Albuquerque, Artesia, Hobbs, Carlsbad, and Gallup areas."
              }
            },
            {
              "@type": "Question",
              "name": "Do you buy equipment from Permian Basin operations in New Mexico?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "Yes! We purchase oil field equipment, gas processing equipment, pipeline valves, and production facility instrumentation from New Mexico's Permian Basin operations in Hobbs, Carlsbad, Artesia, and Lovington. We handle both upstream and midstream equipment purchases with expertise in desert operations."
              }
            },
            {
              "@type": "Question",
              "name": "What documentation is required for New Mexico facilities?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "We provide complete regulatory compliance documentation including proper disposal certificates, material transfer records, and all required environmental paperwork to ensure your facility remains compliant with New Mexico Environment Department and federal regulations."
              }
            },
            {
              "@type": "Question",
              "name": "Do you coordinate with planned shutdowns in New Mexico?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "Absolutely! We work within your maintenance schedule to efficiently remove surplus equipment while maximizing your return on investment. Our team understands New Mexico's unique operational challenges and scheduling requirements for refineries and gas processing plants."
              }
            },
            {
              "@type": "Question",
              "name": "How do you price equipment from New Mexico facilities?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "Our pricing considers current market conditions, equipment condition, manufacturer specifications, and regional demand. We pay significantly above scrap prices for functional equipment and provide competitive pricing for all New Mexico facilities, from major refineries in Artesia to smaller processing plants throughout the Permian Basin."
              }
            }
          ]
        },
        {
          "@type": "Service",
          "@id": "https://valvesalessupply.com/states/new-mexico/#service",
          "serviceType": "Industrial Equipment Purchasing",
          "provider": {
            "@type": "LocalBusiness",
            "name": "ValveSalesSupply"
          },
          "areaServed": {
            "@type": "State",
            "name": "New Mexico",
            "containsPlace": [
              {"@type": "City", "name": "Albuquerque"},
              {"@type": "City", "name": "Artesia"},
              {"@type": "City", "name": "Hobbs"},
              {"@type": "City", "name": "Carlsbad"},
              {"@type": "City", "name": "Roswell"},
              {"@type": "City", "name": "Las Cruces"},
              {"@type": "City", "name": "Santa Fe"},
              {"@type": "City", "name": "Rio Rancho"},
              {"@type": "City", "name": "Farmington"},
              {"@type": "City", "name": "Clovis"},
              {"@type": "City", "name": "Gallup"},
              {"@type": "City", "name": "Alamogordo"},
              {"@type": "City", "name": "Lovington"},
              {"@type": "City", "name": "Deming"},
              {"@type": "City", "name": "Portales"},
              {"@type": "City", "name": "Aztec"},
              {"@type": "City", "name": "Bloomfield"},
              {"@type": "City", "name": "Belen"},
              {"@type": "City", "name": "Bernalillo"},
              {"@type": "City", "name": "Espanola"},
              {"@type": "City", "name": "Grants"},
              {"@type": "City", "name": "Las Vegas"},
              {"@type": "City", "name": "Los Alamos"},
              {"@type": "City", "name": "Los Lunas"},
              {"@type": "City", "name": "Raton"},
              {"@type": "City", "name": "Ruidoso"},
              {"@type": "City", "name": "Silver City"},
              {"@type": "City", "name": "Socorro"},
              {"@type": "City", "name": "Sunland Park"},
              {"@type": "City", "name": "Taos"},
              {"@type": "City", "name": "Truth or Consequences"},
              {"@type": "City", "name": "Tucumcari"}
            ]
          },
          "description": "Professional valve buyers serving New Mexico refineries, gas processing plants, and Permian Basin operations. We purchase Fisher control valves, surplus valves, instrumentation, and industrial equipment from facilities throughout New Mexico."
        }
      ]
    };

    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.text = JSON.stringify(schemaData);
    document.head.appendChild(script);

    return () => {
      document.head.removeChild(geoRegion);
      document.head.removeChild(geoPlacename);
      document.head.removeChild(script);
    };
  }, []);

  const newMexicoCities = [
    'Alamogordo', 'Albuquerque', 'Artesia', 'Aztec', 'Belen', 'Bernalillo', 'Bloomfield',
    'Carlsbad', 'Clovis', 'Deming', 'Espanola', 'Farmington', 'Gallup', 'Grants', 'Hobbs',
    'Las Cruces', 'Las Vegas', 'Los Alamos', 'Los Lunas', 'Lovington', 'Portales', 'Raton',
    'Rio Rancho', 'Roswell', 'Ruidoso', 'Santa Fe', 'Silver City', 'Socorro', 'Sunland Park',
    'Taos', 'Truth or Consequences', 'Tucumcari'
  ];

  const faqData = [
    {
      question: "What types of valves do you buy in New Mexico?",
      answer: "We buy all types of industrial valves from New Mexico refineries including Fisher control valves, gate valves, globe valves, ball valves, check valves, butterfly valves, and safety relief valves. We purchase from Western Refining Gallup, Artesia refineries, and Permian Basin facilities throughout Albuquerque, Hobbs, Carlsbad, and Roswell areas."
    },
    {
      question: "How quickly can you respond to New Mexico facilities?",
      answer: "We provide same-day response to all New Mexico refineries and processing facilities. Our regional team can typically be on-site within 3-6 hours for equipment assessments throughout New Mexico, including Albuquerque, Artesia, Hobbs, Carlsbad, and Gallup areas."
    },
    {
      question: "Do you buy equipment from Permian Basin operations in New Mexico?",
      answer: "Yes! We purchase oil field equipment, gas processing equipment, pipeline valves, and production facility instrumentation from New Mexico's Permian Basin operations in Hobbs, Carlsbad, Artesia, and Lovington. We handle both upstream and midstream equipment purchases with expertise in desert operations."
    },
    {
      question: "What documentation is required for New Mexico facilities?",
      answer: "We provide complete regulatory compliance documentation including proper disposal certificates, material transfer records, and all required environmental paperwork to ensure your facility remains compliant with New Mexico Environment Department and federal regulations."
    },
    {
      question: "Do you coordinate with planned shutdowns in New Mexico?",
      answer: "Absolutely! We work within your maintenance schedule to efficiently remove surplus equipment while maximizing your return on investment. Our team understands New Mexico's unique operational challenges and scheduling requirements for refineries and gas processing plants."
    },
    {
      question: "How do you price equipment from New Mexico facilities?",
      answer: "Our pricing considers current market conditions, equipment condition, manufacturer specifications, and regional demand. We pay significantly above scrap prices for functional equipment and provide competitive pricing for all New Mexico facilities, from major refineries in Artesia to smaller processing plants throughout the Permian Basin."
    }
  ];

  return (
    <div className="min-h-screen">
      <Header />
      
      {/* Hero Section */}
      <section className="relative pt-24 pb-16">
        <div 
          className="absolute inset-0 bg-cover bg-center"
          style={{
            backgroundImage: `url('https://readdy.ai/api/search-image?query=New%20Mexico%20oil%20refineries%20gas%20processing%20plants%20Permian%20Basin%20industrial%20facilities%20Artesia%20Gallup%20Albuquerque%20professional%20industrial%20photography&width=1920&height=600&seq=new-mexico-industrial-001&orientation=landscape')`
          }}
        >
          <div className="absolute inset-0 bg-gradient-to-r from-[#1B3A5F]/90 to-[#1B3A5F]/70"></div>
        </div>
        
        <div className="relative z-10 max-w-7xl mx-auto px-6 text-white">
          <div className="max-w-4xl">
            <h1 className="text-5xl font-bold mb-6">We Buy Valves New Mexico</h1>
            <p className="text-xl text-gray-200 mb-8 leading-relaxed">
              Leading <strong>valve buyers New Mexico</strong> - We purchase surplus valves, control valves, 
              instrumentation, and industrial equipment from Albuquerque, Artesia, Hobbs, Carlsbad, and Permian Basin facilities. 
              Same-day response and competitive pricing for all New Mexico operations.
            </p>
            <div className="flex flex-col sm:flex-row gap-4">
              <a
                href="tel:214-854-5638"
                className="bg-white text-[#1B3A5F] px-8 py-4 rounded-full font-bold text-lg hover:bg-gray-100 transition-all duration-300 inline-flex items-center justify-center whitespace-nowrap"
              >
                <i className="ri-phone-line mr-2"></i>
                CALL 214-854-5638
              </a>
              <Link
                to="/contact"
                className="border-2 border-white text-white px-8 py-4 rounded-full font-bold text-lg hover:bg-white hover:text-[#1B3A5F] transition-all duration-300 inline-flex items-center justify-center whitespace-nowrap"
              >
                GET NEW MEXICO QUOTE
                <i className="ri-arrow-right-line ml-2"></i>
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* New Mexico Market Overview */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid lg:grid-cols-2 gap-16 items-center">
            <div>
              <h2 className="text-[#1B3A5F] text-4xl font-bold mb-6">New Mexico Industrial Equipment Buyer</h2>
              <p className="text-gray-600 text-lg mb-6 leading-relaxed">
                New Mexico's strategic location in the <strong className="text-[#1B3A5F]">Permian Basin</strong> makes it a critical energy state with significant 
                refining and gas processing operations requiring professional <strong className="text-[#1B3A5F]">surplus equipment removal</strong> 
                services during facility upgrades and maintenance. From the refineries in Artesia to the gas processing plants in Hobbs and Carlsbad, 
                New Mexico's energy infrastructure demands experienced equipment buyers who understand desert operations.
              </p>
              <p className="text-gray-600 text-lg mb-8 leading-relaxed">
                As experienced <strong className="text-[#1B3A5F]">New Mexico valve buyers</strong>, we understand 
                the unique challenges of desert operations and provide specialized equipment purchasing services 
                throughout the Land of Enchantment. Our team has extensive experience with Permian Basin facilities, 
                refinery turnarounds, and gas processing plant upgrades across all major New Mexico cities.
              </p>
              
              <div className="grid md:grid-cols-3 gap-6">
                <div className="text-center">
                  <div className="text-[#1B3A5F] text-3xl font-bold">30+</div>
                  <div className="text-gray-600">New Mexico Cities</div>
                </div>
                <div className="text-center">
                  <div className="text-[#1B3A5F] text-3xl font-bold">3-6 Hours</div>
                  <div className="text-gray-600">Response Time</div>
                </div>
                <div className="text-center">
                  <div className="text-[#1B3A5F] text-3xl font-bold">15+ Years</div>
                  <div className="text-gray-600">Permian Experience</div>
                </div>
              </div>
            </div>
            
            <div 
              className="rounded-3xl overflow-hidden shadow-lg bg-cover bg-center h-96"
              style={{
                backgroundImage: `url('https://readdy.ai/api/search-image?query=New%20Mexico%20Permian%20Basin%20oil%20refinery%20gas%20processing%20plant%20desert%20landscape%20industrial%20facility%20modern%20equipment%20professional%20photography&width=600&height=400&seq=newmexico-facilities-010&orientation=landscape')`
              }}
            >
              <div className="bg-gradient-to-t from-[#1B3A5F]/80 to-transparent h-full flex items-end p-8">
                <div className="text-white">
                  <h3 className="text-2xl font-bold mb-2">Permian Basin Operations</h3>
                  <p>Modern facilities in America's most productive oil basin</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* New Mexico Facilities Section */}
      <section className="py-20 bg-[#F5F7FA]">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-[#1B3A5F] text-4xl font-bold mb-4">New Mexico Refinery & Gas Processing Facilities</h2>
            <p className="text-gray-600 text-xl">Serving major energy facilities across the Land of Enchantment</p>
          </div>
          
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {[
              {
                facility: 'Artesia Refineries',
                location: 'Artesia, NM',
                description: 'Major refining operations in southeastern New Mexico',
                icon: 'ri-building-4-line'
              },
              {
                facility: 'Hobbs Gas Processing',
                location: 'Hobbs, NM',
                description: 'Permian Basin gas processing and treatment facilities',
                icon: 'ri-fire-line'
              },
              {
                facility: 'Carlsbad Operations',
                location: 'Carlsbad, NM',
                description: 'Oil and gas production facilities in Eddy County',
                icon: 'ri-oil-line'
              },
              {
                facility: 'Gallup Refinery',
                location: 'Gallup, NM',
                description: 'Western New Mexico refining operations',
                icon: 'ri-building-line'
              },
              {
                facility: 'Lovington Production',
                location: 'Lovington, NM',
                description: 'Lea County oil field production facilities',
                icon: 'ri-drop-line'
              },
              {
                facility: 'Farmington Gas Plants',
                location: 'Farmington, NM',
                description: 'San Juan Basin natural gas processing',
                icon: 'ri-gas-station-line'
              }
            ].map((facility, index) => (
              <div key={index} className="bg-white rounded-2xl p-8 hover:shadow-lg transition-all duration-300">
                <div className="w-16 h-16 bg-[#1B3A5F] rounded-lg flex items-center justify-center mr-4 mt-1">
                  <i className={`${facility.icon} text-white text-3xl`}></i>
                </div>
                <h3 className="text-[#1B3A5F] text-xl font-bold mb-3">{facility.facility}</h3>
                <div className="flex items-center text-gray-600 mb-4">
                  <i className="ri-map-pin-line mr-2"></i>
                  <span>{facility.location}</span>
                </div>
                <p className="text-gray-600">{facility.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* We Buy Surplus Valves New Mexico */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-[#1B3A5F] text-4xl font-bold mb-4">We Buy Surplus Valves New Mexico</h2>
            <p className="text-gray-600 text-xl">New Mexico's trusted surplus valve buyers - serving the Permian Basin</p>
          </div>
          
          <div className="grid lg:grid-cols-2 gap-16 items-center">
            <div>
              <h3 className="text-[#1B3A5F] text-3xl font-bold mb-6">New Mexico Surplus Valve Specialists</h3>
              <p className="text-gray-600 text-lg mb-6 leading-relaxed">
                As <strong className="text-[#1B3A5F]">New Mexico's leading surplus valve buyers</strong>, 
                we specialize in purchasing quality used valves from Permian Basin operations, gas processing 
                plants, and refineries throughout the state. Our understanding of desert operations and 
                extreme conditions ensures proper equipment assessment and fair market pricing for facilities 
                in Albuquerque, Artesia, Hobbs, Carlsbad, and beyond.
              </p>
              
              <div className="space-y-4 mb-8">
                {[
                  {
                    type: 'Permian Basin Valves',
                    description: 'Oil field valves, production valves from New Mexico operations',
                    icon: 'ri-oil-line'
                  },
                  {
                    type: 'Gas Processing Valves',
                    description: 'Control valves from Artesia and Hobbs gas processing plants',
                    icon: 'ri-fire-line'
                  },
                  {
                    type: 'Refinery Equipment',
                    description: 'Gate valves, globe valves from New Mexico refineries',
                    icon: 'ri-building-4-line'
                  },
                  {
                    type: 'Pipeline Valves',
                    description: 'Transmission valves from interstate pipeline systems',
                    icon: 'ri-road-map-line'
                  }
                ].map((valve, index) => (
                  <div key={index} className="flex items-start">
                    <div className="w-12 h-12 bg-[#1B3A5F] rounded-lg flex items-center justify-center mr-4 mt-1">
                      <i className={`${valve.icon} text-white text-xl`}></i>
                    </div>
                    <div>
                      <h4 className="text-[#1B3A5F] font-bold text-lg mb-2">{valve.type}</h4>
                      <p className="text-gray-600">{valve.description}</p>
                    </div>
                  </div>
                ))}
              </div>
              
              <div className="bg-[#F5F7FA] rounded-lg p-6 border border-gray-200">
                <h4 className="text-[#1B3A5F] font-bold mb-3">New Mexico Operation Benefits:</h4>
                <div className="grid md:grid-cols-2 gap-4">
                  <div className="flex items-center">
                    <i className="ri-sun-line text-[#1B3A5F] mr-3"></i>
                    <span className="text-gray-700">Desert conditions expertise</span>
                  </div>
                  <div className="flex items-center">
                    <i className="ri-time-line text-[#1B3A5F] mr-3"></i>
                    <span className="text-gray-700">Same-day response</span>
                  </div>
                  <div className="flex items-center">
                    <i className="ri-money-dollar-circle-line text-[#1B3A5F] mr-3"></i>
                    <span className="text-gray-700">Fair market pricing</span>
                  </div>
                  <div className="flex items-center">
                    <i className="ri-award-line text-[#1B3A5F] mr-3"></i>
                    <span className="text-gray-700">Permian Basin experience</span>
                  </div>
                </div>
              </div>
            </div>
            
            <div 
              className="rounded-3xl overflow-hidden shadow-lg bg-cover bg-center h-96"
              style={{
                backgroundImage: `url('https://readdy.ai/api/search-image?query=New%20Mexico%20surplus%20valves%20control%20valves%20gate%20valves%20ball%20valves%20oil%20field%20equipment%20Permian%20Basin%20warehouse%20organized%20inventory%20professional%20equipment%20storage%20desert%20setting&width=600&height=400&seq=newmexico-surplus-valves-011&orientation=landscape')`
              }}
            >
              <div className="bg-gradient-to-t from-[#1B3A5F]/80 to-transparent h-full flex items-end p-8">
                <div className="text-white">
                  <h3 className="text-2xl font-bold mb-2">Desert Grade Equipment</h3>
                  <p>Quality surplus valves built for extreme desert conditions</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Equipment Categories */}
      <section className="py-20 bg-[#F5F7FA]">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-[#1B3A5F] text-4xl font-bold mb-4">Equipment We Buy in New Mexico</h2>
            <p className="text-gray-600 text-xl">Comprehensive purchasing services for all industrial equipment types</p>
          </div>
          
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
            {[
              {
                category: 'Fisher Control Valves',
                items: ['Fisher DVC6200', 'Fisher 667 Actuators', 'Fisher Level Controllers', 'Fisher Regulators'],
                icon: 'ri-settings-3-line'
              },
              {
                category: 'Gate & Globe Valves',
                items: ['API 600 Gate Valves', 'Globe Control Valves', 'Wedge Gate Valves', 'Y-Pattern Globes'],
                icon: 'ri-tools-line'
              },
              {
                category: 'Ball & Check Valves',
                items: ['Trunnion Ball Valves', 'Floating Ball Valves', 'Swing Check Valves', 'Dual Plate Checks'],
                icon: 'ri-checkbox-circle-line'
              },
              {
                category: 'Instrumentation',
                items: ['Rosemount Transmitters', 'Pressure Gauges', 'Flow Meters', 'Level Instruments'],
                icon: 'ri-dashboard-line'
              }
            ].map((category, index) => (
              <div key={index} className="bg-white rounded-2xl p-8 hover:shadow-lg transition-all duration-300">
                <div className="w-16 h-16 bg-[#1B3A5F] rounded-lg flex items-center justify-center mb-6">
                  <i className={`${category.icon} text-white text-3xl`}></i>
                </div>
                <h3 className="text-[#1B3A5F] text-xl font-bold mb-4">{category.category}</h3>
                <ul className="space-y-2">
                  {category.items.map((item, idx) => (
                    <li key={idx} className="flex items-start text-gray-600">
                      <i className="ri-check-line text-[#14B8A6] mr-2 mt-1"></i>
                      <span>{item}</span>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Major Service Areas */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <h2 className="text-3xl font-bold text-gray-900 mb-12 text-center">Major New Mexico Service Areas</h2>
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            <a href="/albuquerque" className="group bg-gray-50 rounded-lg p-8 hover:shadow-xl transition-all duration-300 cursor-pointer">
              <div className="flex items-center mb-4">
                <i className="ri-building-line text-3xl text-teal-600 mr-4"></i>
                <h3 className="text-xl font-bold text-gray-900 group-hover:text-teal-600 transition-colors">Albuquerque</h3>
              </div>
              <p className="text-gray-600 mb-4">100+ Industrial Facilities</p>
              <p className="text-sm text-gray-500">6-8 hour response time</p>
            </a>

            <a href="/artesia" className="group bg-gray-50 rounded-lg p-8 hover:shadow-xl transition-all duration-300 cursor-pointer">
              <div className="flex items-center mb-4">
                <i className="ri-oil-line text-3xl text-teal-600 mr-4"></i>
                <h3 className="text-xl font-bold text-gray-900 group-hover:text-teal-600 transition-colors">Artesia</h3>
              </div>
              <p className="text-gray-600 mb-4">Navajo Refinery Hub</p>
              <p className="text-sm text-gray-500">4-6 hour response time</p>
            </a>

            <a href="/hobbs" className="group bg-gray-50 rounded-lg p-8 hover:shadow-xl transition-all duration-300 cursor-pointer">
              <div className="flex items-center mb-4">
                <i className="ri-oil-line text-3xl text-teal-600 mr-4"></i>
                <h3 className="text-xl font-bold text-gray-900 group-hover:text-teal-600 transition-colors">Hobbs</h3>
              </div>
              <p className="text-gray-600 mb-4">Permian Basin Center</p>
              <p className="text-sm text-gray-500">4-6 hour response time</p>
            </a>

            <a href="/roswell" className="group bg-gray-50 rounded-lg p-8 hover:shadow-xl transition-all duration-300 cursor-pointer">
              <div className="flex items-center mb-4">
                <i className="ri-oil-line text-3xl text-teal-600 mr-4"></i>
                <h3 className="text-xl font-bold text-gray-900 group-hover:text-teal-600 transition-colors">Roswell</h3>
              </div>
              <p className="text-gray-600 mb-4">Holly Refinery Area</p>
              <p className="text-sm text-gray-500">6-8 hour response time</p>
            </a>

            <a href="/carlsbad" className="group bg-gray-50 rounded-lg p-8 hover:shadow-xl transition-all duration-300 cursor-pointer">
              <div className="flex items-center mb-4">
                <i className="ri-oil-line text-3xl text-teal-600 mr-4"></i>
                <h3 className="text-xl font-bold text-gray-900 group-hover:text-teal-600 transition-colors">Carlsbad</h3>
              </div>
              <p className="text-gray-600 mb-4">Delaware Basin & Potash</p>
              <p className="text-sm text-gray-500">3-5 hour response time</p>
            </a>

            <a href="/farmington" className="group bg-gray-50 rounded-lg p-8 hover:shadow-xl transition-all duration-300 cursor-pointer">
              <div className="flex items-center mb-4">
                <i className="ri-gas-station-line text-3xl text-teal-600 mr-4"></i>
                <h3 className="text-xl font-bold text-gray-900 group-hover:text-teal-600 transition-colors">Farmington</h3>
              </div>
              <p className="text-gray-600 mb-4">San Juan Basin Gas Hub</p>
              <p className="text-sm text-gray-500">3-5 hour response time</p>
            </a>
          </div>
        </div>
      </section>

      {/* FAQ Section */}
      <section className="py-20 bg-white">
        <div className="max-w-4xl mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-[#1B3A5F] text-4xl font-bold mb-4">New Mexico Valve Buyers - Frequently Asked Questions</h2>
            <p className="text-gray-600 text-xl">Common questions about selling equipment to New Mexico buyers</p>
          </div>
          
          <div className="space-y-8">
            {faqData.map((faq, index) => (
              <div key={index} className="bg-[#F5F7FA] rounded-2xl p-8">
                <h3 className="text-[#1B3A5F] text-xl font-bold mb-4">{faq.question}</h3>
                <p className="text-gray-700 text-lg leading-relaxed">{faq.answer}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Contact CTA */}
      <section className="py-20 bg-[#1B3A5F]">
        <div className="max-w-4xl mx-auto px-6 text-center text-white">
          <h2 className="text-4xl font-bold mb-6">Ready to Sell Your New Mexico Equipment?</h2>
          <p className="text-xl text-gray-200 mb-8 leading-relaxed">
            Get a competitive quote for your surplus valves and industrial equipment. 
            Our New Mexico team provides same-day response and fair market pricing.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a
              href="tel:214-854-5638"
              className="bg-white text-[#1B3A5F] px-8 py-4 rounded-full font-bold text-lg hover:bg-gray-100 transition-all duration-300 inline-flex items-center justify-center whitespace-nowrap"
            >
              <i className="ri-phone-line mr-2"></i>
              CALL 214-854-5638
            </a>
            <Link
              to="/contact"
              className="border-2 border-white text-white px-8 py-4 rounded-full font-bold text-lg hover:bg-white hover:text-[#1B3A5F] transition-all duration-300 inline-flex items-center justify-center whitespace-nowrap"
            >
              REQUEST NEW MEXICO QUOTE
              <i className="ri-arrow-right-line ml-2"></i>
            </Link>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default NewMexico;
